
export interface PortfolioItemData {
  title: string;
  subtitle: string;
  image: string;
  link: string;
  linkText?: string;
  videoId?: string;
  isExternalLink?: boolean;
}

export const photoItems: PortfolioItemData[] = [
  {
    title: "MARTYNA + FILIP",
    subtitle: "Pałac Konary. Ślub kościelny plenerowy",
    image: "/lovable-uploads/171da0e4-a1c9-4be6-9b16-a6de6b9d5632.png",
    link: "https://czuleklisze.pl/palac-konary",
    linkText: "ZOBACZ ZDJĘCIA",
    isExternalLink: true
  },
  {
    title: "JULIA + MATEUSZ",
    subtitle: "Złoty Jar. Wesele w górskiej willi",
    image: "/lovable-uploads/ce0839f6-fafc-4f78-af58-664c8a01d775.png",
    link: "https://czuleklisze.pl/slub-zloty-jar-wesele",
    linkText: "ZOBACZ ZDJĘCIA",
    isExternalLink: true
  },
  {
    title: "ANETA + ADAM",
    subtitle: "Pałac Żeleńskich Grodkowice",
    image: "/lovable-uploads/d5ebe164-7039-4677-8321-212b20eb2bff.png",
    link: "https://czuleklisze.pl/wesele-palac-zelenskich-slub",
    linkText: "ZOBACZ ZDJĘCIA",
    isExternalLink: true
  }
];

export const filmItems: PortfolioItemData[] = [
  {
    title: "JULIA + MATEUSZ",
    subtitle: "Złoty Jar. Wesele w górskiej willi",
    image: "/lovable-uploads/456f9d67-7c09-44bc-b716-a6e8270d986b.png",
    link: "https://vimeo.com/1036131976",
    videoId: "1036131976"
  },
  {
    title: "ALEKSANDRA + RADOSŁAW",
    subtitle: "Siedlisko 28",
    image: "/lovable-uploads/77118aae-7026-4be4-8432-459367cd51bd.png",
    link: "https://vimeo.com/1050860049",
    videoId: "1050860049"
  },
  {
    title: "MARTYNA + FILIP",
    subtitle: "Pałac Konary. Ślub kościelny plenerowy",
    image: "/lovable-uploads/c7eee809-8314-496e-9be8-ec4e5be22ec9.png",
    link: "https://vimeo.com/1036134618",
    videoId: "1036134618"
  }
];
